import React from 'react'
import styled from 'styled-components'
import { LaTercera } from '@labcon/copesa-logos'
import logoChile3DBlock from '@/images/logo-chile3d-block.svg'
import logoGfk from '@/images/logo-gfk.svg'

const StMonolith = styled.div`
  border: 1px solid #ccc;
  background-color: white;
  border-radius: 0.5rem;
  padding: 4rem 4rem 0;
  @media (max-width: 768px) {
    padding: 2rem 2rem 0;
  }
  text-align: center;
  header {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(2, 1fr);
    img {
      max-height: 100px;
    }
    div:last-child {
      display: flex;
      justify-content: flex-end;
    }
  }
  .content {
    padding: 4rem;
    @media (max-width: 768px) {
      padding: 4rem 1rem;
    }
    h1 {
      text-transform: uppercase;
      font-weight: bold;
    }
    hr {
      max-width: 60px;
      display: block;
      margin: 40px auto;
      border-width: 3px;
      border-color: black;
    }
  }
  footer {
    overflow: hidden;
    position: relative;
    padding: 0 4rem 12rem;
    @media (max-width: 768px) {
      padding: 0 4rem 6rem;
    }
    svg {
      max-width: 300px;
      margin: 0 auto;
    }
    span {
      font-size: 10rem;
      font-weight: 900;
      position: absolute;
      display: block;
      bottom: 0;
      left: 0;
      right: 0;
      line-height: 0.6;
      letter-spacing: -0.5rem;
      @media (max-width: 768px) {
        font-size: 6rem;
      }
    }
  }
`

const Monolith = ({ category, brand }) => {
  return (
    <StMonolith>
      <header>
        <div>
          <img src={logoChile3DBlock} alt="Chile 3D" />
        </div>
        <div>
          <img src={logoGfk} alt="GFK" />
        </div>
      </header>
      <div className="content">
        <h1>{brand}</h1>
        <hr />
        {category ? (
          <h2>
            Marca más valorada por los chilenos en la categoría {category}
          </h2>
        ) : (
          <h2>Marca de excelencia para los chilenos</h2>
        )}
      </div>
      <footer>
        <LaTercera red="black" />
        <span>2022</span>
      </footer>
    </StMonolith>
  )
}

export default Monolith
